/**
 * Updates all saved prompts after successful save operation
 * @param {Array} categories - The category tree
 * @param {Array} changedItems - List of changed categories
 */
export const updateSavedPrompts = (categories, changedItems) => {
  // Update each changed category
  for (const item of changedItems) {
    findAndUpdateCategory(categories, item)
  }

  // Clean up all temporary variables
  cleanupTemporaryChanges(categories)
}

/**
 * Finds and updates a specific category in the tree
 * @private
 * @param {Array} categoryList - The category list/tree
 * @param {Object} changedItem - Changed category data
 * @returns {boolean} - True if category was found and updated
 */
const findAndUpdateCategory = (categoryList, changedItem) => {
  for (const category of categoryList || []) {
    // Update if category ID matches
    if (category.id === changedItem.categoryId) {
      updateCategoryPrompts(category, changedItem)
      return true
    }

    // Search in subcategories if they exist
    if (category.children && category.children.length) {
      if (findAndUpdateCategory(category.children, changedItem)) {
        return true
      }
    }
  }

  return false
}

/**
 * Updates a category's prompt values
 * @private
 * @param {Object} category - The category to update
 * @param {Object} changedItem - New values
 */
const updateCategoryPrompts = (category, changedItem) => {
  if (!category.prompt) {
    category.prompt = {}
  }

  // Transfer temporary values to permanent values
  category.prompt.image_prompt = changedItem.imagePrompt
  category.prompt.video_prompt = changedItem.videoPrompt

  // Reset change status
  category.hasPromptChanges = false
}

/**
 * Cleans up temporary changes in all categories
 * @private
 * @param {Array} categoryList - The category list/tree
 */
const cleanupTemporaryChanges = (categoryList) => {
  for (const category of categoryList || []) {
    if (category.prompt) {
      // Clean up temporary variables
      delete category.prompt.tempImagePrompt
      delete category.prompt.tempVideoPrompt
    }

    // Clean up subcategories
    if (category.children && category.children.length) {
      cleanupTemporaryChanges(category.children)
    }
  }
}
